import mapboxgl from "mapbox-gl";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import mapPin from "../../../../../assets/images/map/defaultIcons/mapmarker_perfect.gltf";
import { map } from "../../map.sideEffects/useMap.sideEffects.js";
import { getNodeById } from "../../../../../functions/classes/node.class.js";
import { defaultZooms } from "../filter.map";
import svgTerminalMarker from "../../../../../assets/images/map/staticIcons/TerminalMarker.svg";
import svgTerminalMarkerShape from "../../../../../assets/images/map/staticIcons/TerminalMarkerShape.svg";
import pngTerminalMarker from "../../../../../assets/images/map/staticIcons/TerminalMarker.png";

export let customLayer;

const svgBase64 =
  "data:image/svg+xml;base64,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";

export function createTerminalPinSymbol(isTerminal, defaultStartNode) {
  if (defaultStartNode == null || map.getLayer("3d-model")) return;

  let node = getNodeById(defaultStartNode);
  if (!node) return;
  // const getModelTransform = ({ modelAltitude = 6.5, scaleFactor = 1 } = {}) => {
  //   // parameters to ensure the model is georeferenced correctly on the map
  //   const modelOrigin = node.geometry.coordinates;
  //   const modelRotate = [Math.PI / 2, 0, 0];

  //   const modelAsMercatorCoordinate = mapboxgl.MercatorCoordinate.fromLngLat(
  //     modelOrigin,
  //     modelAltitude
  //   );
  //   return {
  //     translateX: modelAsMercatorCoordinate.x,
  //     translateY: modelAsMercatorCoordinate.y,
  //     translateZ: modelAsMercatorCoordinate.z,
  //     rotateX: modelRotate[0],
  //     rotateY: modelRotate[1],
  //     rotateZ: modelRotate[2],
  //     /* Since the 3D model is in real world meters, a scale transform needs to be
  //      * applied since the CustomLayerInterface expects units in MercatorCoordinates.
  //      */
  //     scale:
  //       modelAsMercatorCoordinate.meterInMercatorCoordinateUnits() *
  //       scaleFactor,
  //   };
  // };

  // transformation parameters to position, rotate and scale the 3D model onto the map
  const size = 400;

  const pulsingDot = {
    width: size,
    height: size,
    data: new Uint8Array(size * size * 4),

    // get rendering context for the map canvas when layer is added to the map
    onAdd() {
      const canvas = document.createElement("canvas");
      canvas.width = this.width;
      canvas.height = this.height;
      this.context = canvas.getContext("2d");
    },

    render() {
      const duration = 1000;
      const t = (performance.now() % duration) / duration;

      const radius = (size / 2) * 0.3;
      const outerRadius = (size / 2) * 0.7 * t + radius;
      const context = this.context;

      // Calculate vertical movement
      const movementAmplitude = 10; // max number of pixels the dot should move up and down
      const verticalPosition =
        this.height / 2 + movementAmplitude * Math.sin(t * 2 * Math.PI); // sine function for smooth oscillation

      // Clear previous frame
      context.clearRect(0, 0, this.width, this.height);

      // Draw the larger SVG image to replace the outer shape with fading effect
      const largerImage = new Image();
      largerImage.src = svgTerminalMarkerShape; // Use the SVG image as the source

      if (largerImage.complete) {
        drawLargerImage();
      } else {
        largerImage.onload = drawLargerImage;
      }

      function drawLargerImage() {
        // Set global alpha for fading effect
        context.globalAlpha = 1 - t;

        // Draw the larger SVG image at a scaled size
        const scale = 1.5; // Increase the size by 50%
        context.drawImage(
          largerImage,
          (context.canvas.width - outerRadius * 2 * scale) / 2,
          verticalPosition - outerRadius * scale,
          outerRadius * 2 * scale,
          outerRadius * 2 * scale
        );

        // Reset global alpha to default
        context.globalAlpha = 1.0;
      }

      // Draw the main SVG image as the inner marker
      const image = new Image();
      image.src = svgTerminalMarker; // Use the SVG image as the source

      if (image.complete) {
        drawImage();
      } else {
        image.onload = drawImage;
      }

      function drawImage() {
        context.drawImage(
          image,
          (context.canvas.width - radius * 2) / 2,
          verticalPosition - radius,
          radius * 2,
          radius * 2
        ); // Adjust positioning as needed
      }

      this.data = context.getImageData(0, 0, this.width, this.height).data;

      map.triggerRepaint();

      return true;
    },

    // Das ist ein weiterer Versuch, aber hat seine schwächen mit der duplizierten GRafik!
    // Besser, aber nicht gut.
    // render() {
    //   const duration = 1000;
    //   const t = (performance.now() % duration) / duration;

    //   const radius = (size / 2) * 0.3;
    //   const outerRadius = (size / 2) * 0.7 * t + radius;
    //   // const extendedLength = outerRadius * 1.5; // Extend the length by 150%
    //   const context = this.context;

    //   // Calculate vertical movement
    //   const movementAmplitude = 10; // max number of pixels the dot should move up and down
    //   const verticalPosition =
    //     this.height / 2 + movementAmplitude * Math.sin(t * 2 * Math.PI); // sine function for smooth oscillation

    //   // Clear previous frame
    //   context.clearRect(0, 0, this.width, this.height);

    //   // Draw the larger SVG image to replace the outer shape
    //   const largerImage = new Image();
    //   largerImage.src = svgTerminalMarkerShape; // Use the SVG image as the source

    //   if (largerImage.complete) {
    //     drawLargerImage();
    //   } else {
    //     largerImage.onload = drawLargerImage;
    //   }

    //   function drawLargerImage() {
    //     // Draw the larger SVG image at a scaled size
    //     const scale = 1.5; // Increase the size by 50%
    //     context.drawImage(
    //       largerImage,
    //       69 * 2 - outerRadius * scale,
    //       verticalPosition - outerRadius * scale,
    //       outerRadius * 2 * scale,
    //       outerRadius * 2 * scale
    //     ); // Adjust positioning and size as needed
    //     // context.drawImage(
    //     //   largerImage,
    //     //   0,
    //     //   verticalPosition - outerRadius * scale
    //     // );
    //   }

    //   // Draw the main SVG image as the inner marker
    //   const image = new Image();
    //   image.src = svgTerminalMarker; // Use the SVG image as the source

    //   if (image.complete) {
    //     drawImage();
    //   } else {
    //     image.onload = drawImage;
    //   }

    //   function drawImage() {
    //     context.drawImage(image, 0, verticalPosition - radius);
    //     // context.drawImage(image, 69 / 2 - radius, verticalPosition - radius); // Adjust positioning as needed
    //   }

    //   this.data = context.getImageData(0, 0, this.width, this.height).data;

    //   map.triggerRepaint();

    //   return true;
    // },

    // Das ist zwar gut, aber die äußere Teardrop-Form sieht bescheiden aus.
    // render() {
    //   const duration = 1000;
    //   const t = (performance.now() % duration) / duration;

    //   const radius = (size / 2) * 0.3;
    //   const outerRadius = (size / 2) * 0.7 * t + radius;
    //   const extendedLength = outerRadius * 2.5; // Extend the length by 150%
    //   const context = this.context;

    //   // Calculate vertical movement
    //   const movementAmplitude = 10; // max number of pixels the dot should move up and down
    //   const verticalPosition =
    //     this.height / 2 + movementAmplitude * Math.sin(t * 2 * Math.PI); // sine function for smooth oscillation

    //   // Clear previous frame
    //   context.clearRect(0, 0, this.width, this.height);

    //   // Draw the entire teardrop as one path
    //   context.beginPath();
    //   context.arc(
    //     this.width / 2,
    //     verticalPosition,
    //     outerRadius,
    //     -Math.PI,
    //     0,
    //     false
    //   ); // Top half circle
    //   context.quadraticCurveTo(
    //     this.width / 2,
    //     verticalPosition + extendedLength,
    //     this.width / 2 - outerRadius,
    //     verticalPosition
    //   ); // Draw point
    //   context.closePath(); // Complete the path for filling

    //   // Style for outer teardrop
    //   context.fillStyle = `rgba(255, 200, 200,${1 - t})`;
    //   context.fill();
    //   // context.strokeStyle = "white";
    //   // context.lineWidth = 2 + 4 * (1 - t);
    //   // context.stroke(); // Apply border only once for the whole shape

    //   // // Draw the solid inner teardrop
    //   // context.beginPath();
    //   // context.arc(this.width / 2, verticalPosition, radius, -Math.PI, 0, false);
    //   // context.quadraticCurveTo(
    //   //   this.width / 2,
    //   //   verticalPosition + radius * 2.5,
    //   //   this.width / 2 - radius,
    //   //   verticalPosition
    //   // ); // Extend the inner drop
    //   // context.closePath(); // Complete the path for filling

    //   // context.fillStyle = "rgba(255, 100, 100, 1)";
    //   // context.fill();
    //   // context.strokeStyle = "white";
    //   // context.lineWidth = 2 + 4 * (1 - t);
    //   // context.stroke(); // Apply border only once for the inner shape

    //   const image = new Image();
    //   image.src = svgTerminalMarker; // Use the imported SVG file as the source

    //   // Check if the image is already loaded
    //   if (image.complete) {
    //     // If the image is already loaded, draw it immediately
    //     drawImage();
    //   } else {
    //     // If the image is not yet loaded, wait for the 'load' event
    //     image.onload = drawImage;
    //   }

    //   // Function to draw the image onto the canvas
    //   function drawImage() {
    //     // Draw the image onto the canvas at its natural position (top-left corner)
    //     // context.drawImage(image, 0, 0);
    //     context.drawImage(image, 66, verticalPosition - 33); // Adjust positioning as needed
    //   }

    //   // update this image's data with data from the canvas
    //   this.data = context.getImageData(0, 0, this.width, this.height).data;

    //   // continuously repaint the map, resulting in the smooth animation of the dot
    //   map.triggerRepaint();

    //   // return `true` to let the map know that the image was updated
    //   return true;
    // },
  };

  map.addImage("pulsing-dot", pulsingDot, { pixelRatio: 2 });

  map.addSource("points", {
    type: "geojson",
    data: {
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: node.geometry.coordinates,
          },
        },
      ],
    },
  });
  map.addLayer({
    id: "points",
    type: "symbol",
    source: "points",
    layout: {
      "icon-image": "pulsing-dot",
    },
  });

  // customLayer = {
  //   modelTransform: getModelTransform(),
  //   id: "3d-model",
  //   type: "custom",
  //   renderingMode: "3d",
  //   mixer: null,
  //   node: node,
  //   clock: new THREE.Clock(),
  //   model: null,

  //   onAdd: function (map, gl) {
  //     this.camera = new THREE.Camera();
  //     this.scene = new THREE.Scene();

  //     // create two three.js lights to illuminate the model
  //     const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5);
  //     directionalLight.position.set(0, -140, 200).normalize();
  //     this.scene.add(directionalLight);

  //     const directionalLight2 = new THREE.HemisphereLight(
  //       0x81b8ff,
  //       0xe1e598,
  //       1
  //     );
  //     directionalLight2.position.set(0, 105, 150).normalize();
  //     this.scene.add(directionalLight2);

  //     // use the three.js GLTF loader to add the 3D model to the three.js scene
  //     const loader = new GLTFLoader();
  //     loader.load(mapPin, (gltf) => {
  //       this.model = gltf.scene;

  //       this.scene.add(this.model);
  //       // -- animation start
  //       this.mixer = new THREE.AnimationMixer(this.model);
  //       this.mixer.clipAction(gltf.animations[0]).play();
  //       gltf.scene.position.set(0, 0, 0);
  //       // -- animation end
  //     });
  //     this.map = map;

  //     // use the Mapbox GL JS map canvas for three.js
  //     this.renderer = new THREE.WebGLRenderer({
  //       canvas: map.getCanvas(),
  //       context: gl,
  //       antialias: false,
  //     });

  //     this.renderer.autoClear = false;
  //   },
  //   lastZoomChange: undefined,
  //   render: function (gl, matrix) {
  //     if (
  //       this.map.getZoom() < defaultZooms.buildings.end &&
  //       this.lastZoomChange !== "toFar"
  //     ) {
  //       this.lastZoomChange = "toFar";
  //       this.modelTransform = getModelTransform({
  //         modelAltitude: 50,
  //         scaleFactor: 3,
  //       });
  //     }
  //     if (
  //       this.map.getZoom() > defaultZooms.buildings.end &&
  //       this.lastZoomChange !== "toClose"
  //     ) {
  //       this.lastZoomChange = "toClose";
  //       this.modelTransform = getModelTransform();
  //     }

  //     const rotationX = new THREE.Matrix4().makeRotationAxis(
  //       new THREE.Vector3(1, 0, 0),
  //       this.modelTransform.rotateX
  //     );
  //     const rotationY = new THREE.Matrix4().makeRotationAxis(
  //       new THREE.Vector3(0, 1, 0),
  //       this.modelTransform.rotateY
  //     );
  //     const rotationZ = new THREE.Matrix4().makeRotationAxis(
  //       new THREE.Vector3(0, 0, 1),
  //       this.modelTransform.rotateZ
  //     );

  //     const m = new THREE.Matrix4().fromArray(matrix);
  //     const l = new THREE.Matrix4()
  //       .makeTranslation(
  //         this.modelTransform.translateX,
  //         this.modelTransform.translateY,
  //         this.modelTransform.translateZ
  //       )
  //       .scale(
  //         new THREE.Vector3(
  //           this.modelTransform.scale,
  //           -this.modelTransform.scale,
  //           this.modelTransform.scale
  //         )
  //       )
  //       .multiply(rotationX)
  //       .multiply(rotationY)
  //       .multiply(rotationZ);

  //     this.camera.projectionMatrix = m.multiply(l);
  //     this.renderer.resetState();

  //     // -- animation start
  //     const delta = this.clock.getDelta();
  //     if (this.mixer != null) {
  //       this.mixer.update(delta);
  //     }
  //     // -- animation end
  //     this.renderer.render(this.scene, this.camera);
  //     this.map.triggerRepaint();
  //   },
  // };
  // map.addLayer(customLayer);
}
